import React, { Component } from 'react';
import { Button, Collapse, Alert, Label } from 'reactstrap';
import Checkbox from 'rc-checkbox';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import size from 'lodash/size';
import UsersMetricesUI from './Metrics/UsersMetrics';
import NoKPIDataInDateRange from '../../assets/no-kpidata-range.png';

import axios from '../../axios';
import * as actionCreators from '../../modules/actions/index';
import './Analytics.css';
import TabBar from '../../components/TabBar/TabBar';
import Search from '../../components/Search/Search';
import UsersGrid from './DataGrid/UsersGrid';
import Loading from '../../hoc/Loading/Loading';
import * as url from '../../utils/url';
import { plotlyLineTypes, legendPosition,chartMarkerSymbolsVariation,chartMarkerSymbols,
    plotlyMarkerTypes, plotlyLineMarker,diversityFocusOptions} from '../../utils/constants';

import {generateLegendTitle} from '../../utils/chartUtils';

import Plot from "../../utils/customPlotly";
// import ChartPreview from '../ChartPreview/ChartPreview';
import ReactTooltip from 'react-tooltip'


import ExportToCSV from './ExportToCsv/ExportToCsvUsers';
import { objectEncode } from '../../components/Shared/ReusablesUtils';

const searchByUserNamePlaceholder = 'Search users...';
const Filters = 'Filters';
const chartXAxesMessage = 'Data on the chart represents weekly aggregates, starting every Monday.';





class Analytics extends Component {
    constructor(props) {
        super(props);
        // console.log( this.props.user.organizationId )
        this.state = {
            isFilterCollapsed: false,
            noDataFound:false,
            userData:[],
            // diversityFocusOptions:
            // [{type: "gender", name:"Gender"},
            // {type: "ethnicity", name:"Ethnicity"}],
            diversityFocusOptions,
            // selectedDiversity:null,
            selectedDiversity:[],
            searchObject: {
                metrics: ['chartsCreated', 'weeklyWinsAdded', 'toolsCreated', 'storiesCreated','usersCreated','groupsJoined'],
                // startDate: moment().subtract(1, 'month').toISOString(),
                startDate: this.props && this.props.user && this.props.user.organizationId?
                    moment(this.props.user.organizationId.createdDate).toISOString():
                    moment().subtract(1, 'month').toISOString(),
                endDate: moment().toISOString(),
                username: '',
            },
            userDiversity: []
        };
    }
    componentDidMount() {
        // Fetching all users Tab Data
        // this.fetchLatestData();
        // Fetching Users Tab Metrices
        console.log(this.props)

        Promise.all([
                this.fetchLatestData(), 
                this.props.onFetchUserMetrices(),
            ])
            .then(function (results) {

            });
    }


    modifyDateTimestamp = (momentDate, date) => {
        const dateSplit = momentDate.split('T');
        return `${dateSplit[0]}${date === 'startDate' ? 'T00:00:00Z' : 'T23:59:59Z'}`;
    }


    getUserAnalytics = (val)=>{
        this.setState({userData:[]})
        if(val==[]) return null
        let obj =
            {
                diversityField:val,
                startDate: this.props.user.organizationId.createdDate
            }

        axios.get(url.getUserAnalytics( JSON.stringify(obj) )).then( ({data}) => {
            console.log(data, data.data)
            if(data && data.data && data.data.length>0){
                this.setState({userDiversity: data.data,
                    noDataFound:false
                })
                this.createChart("snapshot")
            } else {
                this.setState({
                    userDiversity:[],
                    noDataFound: val})
            }
        } ).catch((error) => {
            console.log(error);
          })
    }


    getCumulativeAnalytics = (val)=>{
        this.setState({userData:[]})
        let obj =
            {
                diversityField:val,
                startDate: this.props.user.organizationId.createdDate
            }

        axios.get(url.getCumulativeAnalytics( JSON.stringify(obj) )).then( ({data}) => {
            console.log(data, data.data)
            if(data && data.data && data.data.length>0){
                this.setState({userDiversity: data.data,
                    noDataFound:false
                })
                this.createChart()
            } else {
                this.setState({
                    userDiversity:[],
                    noDataFound: val})
            }
        } ).catch((error) => {
            console.log(error);
          })
    }



    fetchLatestData = () => {
        const { searchObject: { metrics, startDate, endDate, username } } = this.state;
        
        const { user: { organizationId } } = this.props;
        const getFilterObject = {
            metrics: metrics.toString(),
            startDate: this.modifyDateTimestamp(startDate, 'startDate'),
            endDate: this.modifyDateTimestamp(endDate, 'endDate'),
            username : encodeURIComponent(username),
            organizationId: encodeURIComponent(organizationId._id)
        };
        axios.get(`${url.getUserData}${objectEncode(getFilterObject)}`).then(({ data }) => {
            console.log("---",data.data.data)
            this.props.onFetchUserAnalyticsSuccess(data.data.data);
        });
    }
    toggleCollapse = () => {
        const { isFilterCollapsed } = this.state;
        this.setState({
            isFilterCollapsed: !isFilterCollapsed,
        });
    }

  handleSearch = (e) => {
      const { value } = e.target;
      this.setState({
          searchObject: {
              ...this.state.searchObject,
              username: value,
          },
      }, () => {
          this.fetchLatestData();
      });
  }
  handleMetricsFilter = (metricId, event) => {
      const { checked } = event.target;
      const { metrics } = this.state.searchObject;
    //   console.log(checked, metrics)
      if (checked && metrics !== undefined) {
          metrics.push(metricId);
      } else {
          metrics.splice(metrics.indexOf(metricId), 1);
      }
      this.setState({
          searchObject: {
              ...this.state.searchObject,
              metrics,
          },
      }, () => {
          this.fetchLatestData();
      });
  }
  handleStartDateChange = (date) => {
      this.setState({
          searchObject: {
              ...this.state.searchObject,
              startDate: date,
          },
      }, () => {
          this.fetchLatestData();
      });
  }
  handleEndDateChange = (date) => {
      this.setState({
          searchObject: {
              ...this.state.searchObject,
              endDate: date,
          },
      }, () => {
          this.fetchLatestData();
      });
  }


  handleDiversityOption = (val)=>{
      let {selectedDiversity}=this.state
    //   console.log(selectedDiversity)
    //   let i = selectedDiversity.indexOf(val)
    //   if(i>-1){
    //     selectedDiversity.splice(i,1)
    //   } else {
    //     selectedDiversity.concat(val)
    //   }
    // let {selectedDiversity}=this.state
    // if(selectedDiversity===val){
    //     val=null
    // }
    // let {selectedDiversity}=this.state
    // selectedDiversity=null;
    // selectedDiversity=val;

    // ORIGINAL
    // if(selectedDiversity===val){
    //     val = null
    // }
    // this.setState({selectedDiversity:val})


    if(selectedDiversity.indexOf(val)==-1){
        selectedDiversity.push(val)
    } else {
        selectedDiversity= selectedDiversity.filter(e=> e!=val)
    }
    this.setState({selectedDiversity:[...selectedDiversity]})
  }

  chartLineMarkerGenerator =(type)=>{
    let value = Math.floor(Math.random()*16777215).toString(16)
    let color = `#${value}`.toUpperCase();
    let obj

    if(type==="line"){
      obj = {
        color,
        width: 1
      }
    } else {
      let marker = Math.floor(Math.random()*9)
      let variation = Math.floor(Math.random()*3)
      let symbol = `${chartMarkerSymbols[marker]}${chartMarkerSymbolsVariation[variation]}`
      obj={
        color,
        size: 10,
        symbol,
      }
    }
    return obj
  }
  

  createChart = (val) =>{
      let{userDiversity,userData}=this.state
        let max=null
        let min=null

    if(val==="snapshot"){
        userDiversity.map((e, index) => {  
            console.log(e)

            let y = e.docs.map(b => {
                return b.percent
            })
        
            let x = e.docs.map(a => {
                return a.date
            })
        
            let text = e.docs.map(c => {
                let per = Math.floor(c.percent*100)
                return `count: ${c.diversityCount} of total: ${c.total}`
            })
            let LineColor = plotlyLineTypes[index].color
            let mc = plotlyMarkerTypes.find(e=> {
                return e.color==LineColor?e:null
            })


            let random = Math.random().toString(16) 

            let object = {
                 name: `${e._id}`, 
                 y:y , 
                 x:x, 
                 text:text, 
                line:this.chartLineMarkerGenerator('line'), 
                lines:"scatter",
                marker:this.chartLineMarkerGenerator('marker'), 
                mode:"markers"
            }
            userData.push(object)
          })
    }else {
        userDiversity.map((e, index) => {  
            console.log(e)

            let y = e.docs.map(b => {
                return b.percent
            })
        
            let x = e.docs.map(a => {
                let date = new Date(a.date)
                let dateStr = moment(date).format('YYYY-MM')
                max = max===null? date: date >max? date: max 
                min = min==null? date: date < min ? date: min
                return dateStr
            })

            // let description = generateLegendTitle(kpi,kpi.kpiId.description, index, false, "","")

        
            let text = e.docs.map(c => {
                let per = Math.floor(c.percent*100)
                return `count: ${c.diversityCount} of total: ${c.total}`
            })
             

            let single_res = e.docs[0]._id
            let resultKeys = Object.keys(single_res)


            let di_string=''

            resultKeys.map( (e,idx)=> {
                let val = single_res[e]==null?'None':single_res[e].name
                let res= `[${e}]: ${val}` 
                if(resultKeys.length>1 || resultKeys.length-1!=idx){
                   res= `[${e}]: ${val}, ` 
                } 
                di_string = di_string+res
            })

            let random = Math.random().toString(16) 
            let object = {
                //  name: `${e._id}`, 
                name: di_string,
                description:di_string,
                //  legend: legendTxt,
                 y:y , 
                 x:x, 
                 text:text, 
                line:plotlyLineMarker(random), 
                lines:"scatter",
                marker:plotlyLineMarker(random),
                mode:"lines+markers"
            }
            userData.push(object)
            

          })
         
        
        let dtick = new Date(max).getMonth() != new Date(min).getMonth()? 'M1': 12
        // console.log(minDate, maxDate)

        // maxDate = maxDate.setDate(maxDate.getDate() + 3)
        // minDate = minDate.setDate(minDate.getDate() - 3)

        userDiversity.dtick = dtick
        
    }
  }

  render() {
      const { userData, userDiversity, noDataFound, isFilterCollapsed, searchObject, diversityFocusOptions, selectedDiversity } = this.state;
      const { userAnalytics, userMetrices, history, onFetchUserAnalyticsSuccess } = this.props;


    let yLegend;
    let length = userData.length;
    // -0.7 
    if(length<3){
        yLegend= -0.3
    } else if (length>2 && length<6){
        yLegend= -0.5
    } else if(length>5 && length<9){
        yLegend= -0.7
    } else if(length>8 && length < 11){
        yLegend= -0.9
    }  else if(length>10){
        yLegend= -1.2
    }

//     let tickvalsString = null;
//     if(userData.length === 1 ) {
//       if(userData[0].x.length === 1){
//         tickvalsString = [userData[0].x[0]];
//       }
//     }

//     if(userData.length > 1) {
//     let tickvalsList = userData.map(data => {
//       let xvalues = data.x;
//       return xvalues;
//     });
//     let filteredTickvalsList = tickvalsList.filter(tickValue => tickValue.length === 1);
//     if(tickvalsString==null && tickvalsList.length > 0 && tickvalsList.length === filteredTickvalsList.length) {
//        let firstTickVal = filteredTickvalsList[0][0];
//        let filterTickVal = filteredTickvalsList.filter(tickVal => moment(tickVal[0]).isSame(firstTickVal, 'month'));
//        if(filterTickVal.length === filteredTickvalsList.length){
//         tickvalsString = [firstTickVal];
//        }
//     }
//   }

 let customPlot = userData && userData.length>0?
    <div>
<Plot
      data={userData}
      layout={{
        showlegend: true,
              autosize: true,
              uirevision:true,
              legend: {
                bgcolor:'white',
                // xanchor: "left",
                orientation: "h",
                y:legendPosition(userData.length),
                x:-0.05
              },
              paper_bgcolor:'#F3F3F4',
              plot_bgcolor:'#F3F3F4',
              margin: {
                l: 40,
                r: 30,
                b: 30,
                t: 20,
                pad: 10,
              },
        xaxis : {
          showgrid: false,
          type:'date',
          automargin: true,
          tickformat:'%B, %Y',
        //   tickvals: tickvalsString!==null ? tickvalsString : ' ',
          tickfont : {color:'#313236'},
          title:{standoff:30},
          // fixedrange:true
          // fixedrange:[1,2]

              },
        yaxis : {
                showgrid:true,
                zerolinecolor: '#ffffff',
                zerolinewidth: 1,
                // gridcolor: '#ffffff',
                // gridwidth: 2,
                tickformat: '%',
                tickfont : {color:'#313236'},
                // fixedrange:true,
                automargin:true,
                // autorange:true,
                // dtick:0.1,
                title:{standoff:20},
                // dtick: ((Math.max(...this.props.yRange)/10)),
                range: this.props.yRange,
                rangemode: 'tozero',
              },
              // hovermode:'x',
              hovermode:'closest'
          }}
      // useResizeHandler={true}
      scrollZoom={true}
      // config={{displayModeBar:false}}
      config={{
        // displayModeBar:true, 
        scrollZoom:true,
        // editable:isSafari?false:true,
        modeBarButtonsToAdd:['drawline',
                                  'drawopenpath',
                                  'drawclosedpath',
                                  'drawcircle',
                                  'drawrect',
                                  'eraseshape',
                                 ],
        displaylogo: false,
        // staticPlot:(plotlyData && plotlyData.length>0)?false:true,
        responsive: true,
        toImageButtonOptions: {
          format: 'png', // one of png, svg, jpeg, webp
          // moment(d.createdDate).format('MM/DD/YYYY')
          filename: `Users - ${moment(new Date()).format('MM-D-YYYY')}`,
          height: 600,
          width: null,
          scale: 1 // Multiply title/legend/axis/canvas sizes by this factor
        }
      }}
      className='kpiCharts metrics_charts_margin'
      style={{width:'100%'}}
      
    />
    </div>
    :
    null
    // <img src={NoKPIDataInDateRange} className="no-kpi-date-range"/>
    ;
  
    


      return (
          <div className="mt70 analytics-form">
              <div className="row ml-0 mr-0 mb-3 text-size">
                  <div className="title-text">Metrics</div>
                  <TabBar activeTab="2" history={history} isOrgSetup={this.props.user.organizationId.isSetupSkipped}/>
              </div>
              <div className = "selectOneDI">
                Select one:
            </div>
        <div className="diversityOptionsUA">
          
            {diversityFocusOptions.map((option, index) => {
                return (
                    <span className="col-sm-3 col-md-3 mb20">
                        <Label style={{display: 'inline-flex'}}>
                            {option.name}
                        <Checkbox 
                         checked ={selectedDiversity.length>0&&selectedDiversity.indexOf(option.type)>-1?true:false}
                         onClick={() => this.handleDiversityOption(option.type)}
                        // checked ={selectedDiversity&&selectedDiversity==option.type?true:false}
                        // onClick={() => this.handleDiversityOption(option.type)}
                        />
                        {/* <span className="ml10 focus-check-option">{option.focus}{option.focus == "Other" ? ':': ''}</span> */}
                        </Label>    
                    </span>)
            })}

                    {/* <Button 
                    onClick={()=>this.getUserAnalytics(selectedDiversity)} 
                    className={selectedDiversity && selectedDiversity.length>0?"userAnalyticsBtn": "userAnalyticsBtnDisabled"}>
                        
                          Create Chart
                    </Button> */}


                    {noDataFound!==false?
                        <div className="noDataFound"> 
                            No data was available by {noDataFound}. Please select another option
                        </div>
                        
                        :null
                    }
                </div>

               



            <div className="userDiversityChart">
                <div>
                    {/* <Button onClick={()=>this.getUserAnalytics(selectedDiversity)}
                    className={selectedDiversity && selectedDiversity.length>0?"userAnalyticsBtn": "userAnalyticsBtnDisabled"}
                    >
                        Show Snapshot
                    </Button> */}

                    <Button onClick={()=>this.getCumulativeAnalytics(selectedDiversity)}
                    className={selectedDiversity && selectedDiversity.length>0?"userAnalyticsBtn": "userAnalyticsBtnDisabled"}
                    >
                        Create Chart
                    </Button>
                </div>
                {/* ChartPreview */}



                    {customPlot}

              
            </div>

            {/* <Alert color="info">
            <span className="alert-info-text">
              <span className="alert-info-icon"></span>
              <span>
              note

              </span>
            </span>
          </Alert> */}
                  

              <div className="row p-0 m-0 height40">
                  <Search
                      placeholder={searchByUserNamePlaceholder}
                      handleSearch={this.handleSearch}
                      value={searchObject.username}
                  />
                  {/* <div className="col-lg-2 filter-select col-md-3 col-sm-3 pl0 pr0">
                      <Button color="secondary-filled" onClick={this.toggleCollapse} className="filterBtnStyle">
                          <span className="tool-list-font">
                              <i className="flaticon-equalizer filterBtnTextStyle"></i>{Filters} {size(searchObject.metrics)}
                          </span>
                      </Button>
                  </div> */}
              </div>

              {/* <div className="row p-0 m-0">
                  <Collapse isOpen={isFilterCollapsed} className="col-lg-12 col-sm-12 col-md-12 pr0 pl-0 width100" toggler="#toggler">
                      <UsersMetricesUI
                          userMetrices={userMetrices}
                          searchObject={searchObject}
                          handleMetricsFilter={this.handleMetricsFilter}
                      />
                  </Collapse >
              </div> */}
              
             
              <div>
                 
          
                  
                  <div className="row">
                    {userAnalytics.length > 0 && (
                        <ExportToCSV
                            Analytics={userAnalytics}
                            userMetrices={userMetrices}
                        />
                    )}
                  </div>
              </div>
              <div>
                  <UsersGrid
                  user={this.props.user}
                      userAnalytics={userAnalytics}
                      userMetrices={userMetrices}
                      fetchLatest={this.fetchLatestData}
                      searchObject={searchObject}
                      onFetchUserAnalyticsSuccess={onFetchUserAnalyticsSuccess}
                  />
              </div>
          </div>
      );
  }
}

Analytics.propTypes = {
    userAnalytics: PropTypes.array,
    userMetrices: PropTypes.array,
    history: PropTypes.object,
    onFetchUserAnalyticsSuccess: PropTypes.func.isRequired,
    onFetchUserMetrices: PropTypes.func,
};
const mapStateToProps = state => ({
    userAnalytics: state.dashboard.UsersAnalytics,
    userMetrices: state.dashboard.UsersMetrics,
    user: state.user.profile
});
const mapDispatchToProps = dispatch => ({
    onFetchUserAnalyticsSuccess: (data) => dispatch(actionCreators.fetchUserAnalyticsSuccess(data)),
    onFetchUserMetrices: () => dispatch(actionCreators.fetchUserMetrices()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Loading(Analytics, axios));

